module.exports = __webpack_public_path__ + "images/lab/custom-view-9ce055122d884b0b58a78bbbe4b57eb8.jpg";